$(function() {

  var createOptions = function($selector) {
    return {
      getValue: "word",
      cssClasses: 'col',
      requestDelay: 250,
      url: function(phrase) {
        return "/searches/autosuggest?q=" + encodeURIComponent(phrase.trim());
      },
      list: {
        onChooseEvent: function() {
          var item = $selector.getSelectedItemData();
          var searchLink = item.link;
          if (item.word === 'Fetch Amazon Product') {
            searchLink = searchLink.replace('error_redirect_uri=', 'error_redirect_uri=' + encodeURIComponent(window.location.pathname));
          }
          window.location = searchLink;
        }
      }
    };
  };

  // one instance per input: a shared collection resolves getSelectedItemData
  // against the first input only, sending other inputs to /undefined
  $('*[data-behavior="autocomplete"]').each(function() {
    var $el = $(this);
    $el.easyAutocomplete(createOptions($el));
  });
})
